export default __webpack_public_path__ + "static/media/01.60e972d5.jpg";